import { jsx as r } from "react/jsx-runtime";
import t from "@kmx/mui-icons/KmxCheckCircleStroked";
import e from "@kmx/mui-icons/KmxErrorStroked";
import o from "@kmx/mui-icons/KmxInfoCircleStroked";
import i from "@kmx/mui-icons/KmxWarningStroked";
import { t as m } from "../tokens-D9z8Q6nJ.js";
const l = {
  defaultProps: {
    iconMapping: {
      error: /* @__PURE__ */ r(e, {}),
      info: /* @__PURE__ */ r(o, {}),
      success: /* @__PURE__ */ r(t, {}),
      warning: /* @__PURE__ */ r(i, {}),
      flagged: /* @__PURE__ */ r(o, {})
    }
  },
  styleOverrides: {
    root: {
      variants: [
        {
          props: { variant: "filled" },
          style: {
            fontWeight: m
          }
        }
      ]
    }
  }
};
export {
  l as default
};
